import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  logo: {
    width: 'auto',
    height: 36,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img
        className={classes.logo}
        src="/gasnet-logo-icon.svg"
        alt="GasNet Logo Icon"
      />
    </div>
  );
};

export default LogoIcon;
